const links = {
  github: "https://github.com/meet-majevadiya",
  resume:
    "https://drive.google.com/file/d/1lFvfz0S5JqSIZeVb-C2gIDZ8NGOjJZK1/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/meet-majevadiya-306742184/",
};
export default links;
